let width = document.body.clientWidth;
if (document.querySelectorAll('.home-slider').length > 0) {

    let sliders = document.querySelectorAll('.slider-glide.home-slide');
    for (const slider of sliders) {
        // Dupliquer les slides pour créer un effet infini
        const slidesContainer = slider.querySelector('.glide__slides');
        const slides = slidesContainer.children;
        const slidesArray = Array.from(slides);

        // Cloner les slides pour le mode infini
        slidesArray.forEach(slide => {
            const clone = slide.cloneNode(true);
            slidesContainer.appendChild(clone);
        });

        let glideSlider = new Glide(slider, {
            type: 'carousel',
            perView: slider.dataset.nbslidexxl ? slider.dataset.nbslidexxl : "1",
            autoplay: true,
            hoverpause: true,
            animationDuration: 3000,
            gap: 30,
            rewind: false,
            breakpoints: {
                1399: {
                    perView: slider.dataset.nbslidexl
                },
                1199: {
                    perView: slider.dataset.nbslidelg
                },
                991: {
                    perView: slider.dataset.nbslidemd,
                    gap: 20
                },
                767: {
                    perView: slider.dataset.nbslide,
                    gap: 10
                }
            }
        });

        glideSlider.mount();
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const glideElement = document.querySelector(".actualites-slider .glide");

    if (glideElement) {
        const slideWidth = 377; // largeur "idéale"
        const gap = 30;
        const visibleSlides = 2.5;
        const perViewCalc = Math.ceil(visibleSlides); // donc 3

        const glide = new Glide(glideElement, {
            type: "carousel",
            perView: 3.2,
            focusAt: 0,
            bound: true,
            perTouch: 1, // 👈 essentiel pour avancer slide par slide
            gap: gap,
            autoplay: false,
            hoverpause: true,
            animationDuration: 1000,
            rewind: false,
            breakpoints: {
                1500: {
                    perView: 2.8,
                    focusAt: 0,
                    bound: true,
                    perTouch: 1, // 👈 ici aussi pour mobile
                    gap: 15
                },

                767: {
                perView: 1.2,
                focusAt: 0,
                bound: true,
                perTouch: 1, // 👈 ici aussi pour mobile
                gap: 15
                }
            }
        });

        // Fonction flèches, progress bar, etc.
        glide.on("run.after", () => updateArrowState(glide));
        glide.mount();

        const progressBar = document.querySelector(".home-news .slider-progress-indicator");
        const progressContainer = document.querySelector(".home-news .slider-progress-bar");

        function updateProgress(glideInstance) {
            const perView = glideInstance.settings.perView;
            const totalSlides = glideInstance._c.Html.slides.length;
            const totalSteps = totalSlides - perView;

            const safeSteps = Math.max(totalSteps, 1);
            const barWidthPercent = 100 / (safeSteps + 1);
            progressBar.style.width = `${barWidthPercent}%`;

            const leftPercent = (glideInstance.index / safeSteps) * (100 - barWidthPercent);
            progressBar.style.left = `${leftPercent}%`;
        }

        glide.on("run", () => {
            updateProgress(glide);
        });
        updateProgress(glide);

        progressContainer.addEventListener("click", function (e) {
            const rect = progressContainer.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const containerWidth = rect.width;

            const ratio = clickX / containerWidth;

            const perView = glide.settings.perView;
            const totalSlides = glide._c.Html.slides.length;
            const maxIndex = totalSlides - perView;

            const targetIndex = Math.round(ratio * maxIndex);

            glide.go(`=${targetIndex}`);
        });

        function updateArrowState(glideInstance) {
            // Recherche les flèches dans le parent .home-news au lieu du .glide
            const leftArrow = document.querySelector(".home-news .glide__arrow--left");
            const rightArrow = document.querySelector(".home-news .glide__arrow--right");

            if (!leftArrow || !rightArrow) return;

            if (glideInstance.index === 0) {
                leftArrow.setAttribute("disabled", "true");
            } else {
                leftArrow.removeAttribute("disabled");
            }

            if (glideInstance.index >= glideInstance._c.Html.slides.length - glideInstance.settings.perView) {
                rightArrow.setAttribute("disabled", "true");
            } else {
                rightArrow.removeAttribute("disabled");
            }
        }

        // Sélectionne les flèches externes et les connecte manuellement au slider
        const leftArrow = document.querySelector(".home-news .glide__arrow--left");
        const rightArrow = document.querySelector(".home-news .glide__arrow--right");

        if (leftArrow) {
            leftArrow.addEventListener("click", function (event) {
                event.preventDefault();
                glide.go('<');
            });
        }

        if (rightArrow) {
            rightArrow.addEventListener("click", function (event) {
                event.preventDefault();
                glide.go('>');
            });
        }

        updateArrowState(glide);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const glideElement = document.querySelector(".slider-fullscreen .glide");

    if (glideElement) {
        let glide = new Glide(glideElement, {
            type: "carousel",
            perView: 1, // 1 image par slide
            autoplay: 5000, // Change d’image toutes les 5s
            hoverpause: true, // Stop autoplay au survol
            animationDuration: 1000,
            gap: 0, // Pas d’espace entre les images
            rewind: true, // Active la boucle infinie
        });

        glide.on("run.after", () => updateArrowState(glide));
        glide.mount();

        // Sélection des flèches indépendantes
        const leftArrow = document.querySelector(".slider-fullscreen .glide__arrow--left");
        const rightArrow = document.querySelector(".slider-fullscreen .glide__arrow--right");

        function updateArrowState(glideInstance) {
            if (glideInstance.index === 0) {
                leftArrow.setAttribute("disabled", "true"); // Désactive la flèche gauche au premier slide
            } else {
                leftArrow.removeAttribute("disabled");
            }

            if (glideInstance.index === glideInstance._c.Html.slides.length - 1) {
                rightArrow.setAttribute("disabled", "true"); // Désactive la flèche droite au dernier slide
            } else {
                rightArrow.removeAttribute("disabled");
            }
        }

        // Empêcher le rechargement de la page au clic sur les flèches
        document.querySelectorAll(".slider-fullscreen .glide__arrow").forEach(button => {
            button.addEventListener("click", function (event) {
                event.preventDefault();
            });
        });

        // Initialisation de l'état des flèches
        updateArrowState(glide);
    }
});


document.addEventListener('DOMContentLoaded', function () {
    let lightGalleries = document.querySelectorAll('.lightgallery-carousel');
    if (lightGalleries.length > 0) {
        for (const gallery of lightGalleries) {
            let thisGallery = lightGallery(gallery, {
                counter: true,
                download: false,
                mode: 'lg-slide',
                cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
                subHtmlSelectorRelative: true,
                getCaptionFromTitleOrAlt: gallery.dataset.class == "hideCaption" ? false : true
            });

            if (document.querySelectorAll(gallery.dataset.trigger).length > 0) {
                document.querySelector(gallery.dataset.trigger).addEventListener('click', (e) => {
                    e.preventDefault();
                    gallery.firstElementChild.click();
                });
            }
        }
    }

    let lightGalleriesSimple = document.querySelectorAll('.lightgallery');
    if (lightGalleriesSimple.length > 0) {
        for (const gallery of lightGalleriesSimple) {
            let thisGallery = lightGallery(gallery, {
                plugins: [lgVideo, lgThumbnail, lgZoom],
                counter: true,
                download: false,
                mode: 'lg-slide',
                cssEasing: 'cubic-bezier(.45, .06, .15, 1)',
                subHtmlSelectorRelative: true,
                preload: 1,
                thumbnail: gallery.dataset.thumbnail === "show",
                getCaptionFromTitleOrAlt: gallery.dataset.class !== "hideCaption",
                youTubePlayerParams: {
                    modestbranding: 1,
                    showinfo: 0,
                    controls: 1,
                    rel: 0
                }
            });

            if (document.querySelectorAll(gallery.dataset.trigger).length > 0) {
                let allImagesBtn = document.querySelectorAll(gallery.dataset.trigger);
                for (const imageBtn of allImagesBtn) {
                    imageBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (imageBtn.dataset.imgcount) {
                            gallery.getElementsByTagName('a')[imageBtn.dataset.imgcount].click();
                        } else {
                            gallery.firstElementChild.click();
                        }
                    });
                }
            }
        }
    }
});

// ========================================
// NOUVELLE VERSION V2 - Slider avec ml-container
// ========================================
document.addEventListener("DOMContentLoaded", function () {
    const glideElement = document.querySelector(".home-news-v2 .glide-v2");

    if (glideElement) {
        const gap = 30;

        const glide = new Glide(glideElement, {
            type: "carousel",
            perView: 4.3,
            focusAt: 0,
            bound: true,
            perTouch: 1,
            gap: gap,
            autoplay: false,
            hoverpause: true,
            animationDuration: 1000,
            rewind: false,
            breakpoints: {
                1700: {
                    perView: 3.7,
                    focusAt: 0,
                    bound: true,
                    perTouch: 1,
                    gap: 30
                },
                1500: {
                    perView: 2.8,
                    focusAt: 0,
                    bound: true,
                    perTouch: 1,
                    gap: 15
                },
                767: {
                    perView: 1.3,
                    focusAt: 0,
                    bound: true,
                    perTouch: 1,
                    gap: 15
                }
            }
        });

        glide.mount();

        const progressBar = document.querySelector(".home-news-v2 .slider-progress-indicator");
        const progressContainer = document.querySelector(".home-news-v2 .slider-progress-bar");

        function updateProgress(glideInstance) {
            const perView = glideInstance.settings.perView;
            const totalSlides = glideInstance._c.Html.slides.length;
            const totalSteps = totalSlides - perView;

            const safeSteps = Math.max(totalSteps, 1);
            const barWidthPercent = 100 / (safeSteps + 1);
            progressBar.style.width = `${barWidthPercent}%`;

            const leftPercent = (glideInstance.index / safeSteps) * (100 - barWidthPercent);
            progressBar.style.left = `${leftPercent}%`;
        }

        glide.on("run", () => {
            updateProgress(glide);
        });
        updateProgress(glide);

        progressContainer.addEventListener("click", function (e) {
            const rect = progressContainer.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const containerWidth = rect.width;

            const ratio = clickX / containerWidth;

            const perView = glide.settings.perView;
            const totalSlides = glide._c.Html.slides.length;
            const maxIndex = totalSlides - perView;

            const targetIndex = Math.round(ratio * maxIndex);

            glide.go(`=${targetIndex}`);
        });

        const leftArrow = document.querySelector(".home-news-v2 .glide-v2-left");
        const rightArrow = document.querySelector(".home-news-v2 .glide-v2-right");

        if (leftArrow) {
            leftArrow.addEventListener("click", function (event) {
                event.preventDefault();
                glide.go('<');
            });
        }

        if (rightArrow) {
            rightArrow.addEventListener("click", function (event) {
                event.preventDefault();
                glide.go('>');
            });
        }
    }
});
